import {ComponentChild, FunctionalComponent, h} from "preact";
import './msgBox.scss';
import {useLayoutEffect, useRef} from "preact/hooks";

export const MessageBoxTemplate: FunctionalComponent<{
    me: boolean;
    avt1: string;
    avt2: string;
    merged: boolean;
    typing: boolean;
    msgRenderedCb: (h: number) => void;
    children: ComponentChild;
}> = ({
    me,
    avt1,
    avt2,
    merged,
    typing,
    msgRenderedCb,
    children
}) => {
  
  let meClass = me ? 'me' : '';
  meClass = merged ? `${meClass} merged` : meClass;
  meClass = avt1 ? `${meClass} withAvatar1` : meClass;
  meClass = avt2 ? `${meClass} withAvatar2` : meClass;
  meClass = typing ? `${meClass} typing` : meClass;
  const meRef = useRef<HTMLLIElement>(null);

    useLayoutEffect(() => {
//        meRef.current.scrollIntoView({block: "start", inline: "nearest", behavior: 'smooth'});
        msgRenderedCb(meRef.current?.offsetHeight ?? 0);
    }, []);

    return (
        <li ref={meRef} className={meClass}>
            {avt1 && (<img className="avt" src={avt1} />)}
            {avt2 && (<img className="avt" src={avt2} />)}
          { children }
        </li>
    );
}
